import { render, staticRenderFns } from "./TransportationSection.vue?vue&type=template&id=5fc1a269"
import script from "./TransportationSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransportationSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports